<template>
  <w-card 
    class="white--bg mt2 sh2" 
    v-bind="$attrs" 
    v-bind:class="{fullscreen: isFullscreen, 'panel-collapsed': isCollapsed, 'panel-collapsed': isClosed}" v-bind:contentClass="isCollapsed ? 'panel-collapsed': ''"
  >
    <template #title v-if="!inner">
      <w-toolbar shadown class="py3">
        <w-icon class="primary mr3" md>{{ icon }}</w-icon> 
        <div class="title4">
          {{ title }}
        </div>
        <div class="spacer"></div>
          <template v-if="!hasToolBarButton || appendButton">
          <w-button icon="fal fa-compress" text xs class="mr1" @click="isCollapsed = !isCollapsed"></w-button>
          <w-button icon="fal fa-window-maximize" text xs class="mr1" @click="isFullscreen = !isFullscreen"></w-button>
          <w-button v-if="!appendButton" icon="fal fa-times" text xs class="mr1" @click="teaser()"></w-button>
          </template>
          <template v-if="hasToolBarButton || appendButton">
            <slot name="buttons" />
          </template>
      </w-toolbar>
    </template>

    <slot />
    
    <!-- <w-overlay
      v-model="isFullscreen"
      bg-color="rgba(35, 71, 129, 0.4)">
      <w-spinner />
    </w-overlay> -->
  </w-card>
</template>

<script>
export default {
  name: 'z-page',
  inheritAttrs: false,
  props: {
    inner: {
      type: Boolean,
      default: false
    },
    useIcon: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fal fa-briefcase'
    },
    iconColor: String,
    useSlot: {
      type: Boolean,
      default: false
    },
    appendButton: {
      type: Boolean,
      default: false
    },
    text: String,
    header: String,
    title: String,
    subtitle: String
  },
  data: () => ({
    isFullscreen: false,
    isCollapsed: false,
    isClosed: false
  }),
  methods: {
    teaser() {
      this.isClosed = true
      this.$waveui.notify('Dropping table...', 'error', 3000)
      setTimeout(() => (this.isClosed = false), 3000)
    }
  },
  computed: {
    hasToolBarButton() {
      return !!this.$slots.buttons
    }
  }
}
</script>

<style>


</style>